import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafeUrlPipeModule } from '../pipes/safe-url.pipe';
import { TranslatePipeModule } from '../shared/translate.pipe';
import { WindowService } from '../shared/window.service';
import { ReferralsPageComponent } from './referrals-page/referrals-page.component';

@NgModule({
  imports: [CommonModule, TranslatePipeModule, SafeUrlPipeModule],
  declarations: [ReferralsPageComponent],
  providers: [WindowService],
})
export class ReferralsModule {}



// WEBPACK FOOTER //
// ./ts/app/referrals/referrals.module.ts